import { useEffect, useState } from 'react'
import { getErrorMessage, parseVodId } from '@/shared/lib'
import { VodPageDetailsRecommendationPrefix } from '@/shared/constants'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import { useVODStore } from '@/shared/store'
import { selectVodRows } from '@/shared/store/storeSelectors/vodSelectors'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { IVODServiceToya } from '@/shared/types/services/types/vodService/vodServiceInterfaces'

export function useGetVodRecommendationsTOYA(
    profileId: string,
    productId: string
) {
    const [vodCategoryRows, setVodCategoryRows] = useState<VodRowViewProps[]>(
        []
    )
    const vodRows = useVODStore(selectVodRows)

    const { getRows } = useVODService() as IVODServiceToya

    async function fetchVodRows(rowIndex: string) {
        try {
            const response = await getRows(rowIndex, '0', 10, profileId)
            if (response) {
                setVodCategoryRows(response)
            }
        } catch (error) {
            getErrorMessage('fetchVodRows', error)
        }
    }

    useEffect(() => {
        if (productId && parseVodId(productId || '')) {
            const rowIndex = `${VodPageDetailsRecommendationPrefix}${parseVodId(
                productId || ''
            )}`

            fetchVodRows(rowIndex)
        }
    }, [vodRows.length, productId])

    return { vodCategoryRows }
}
